import { createSelector } from 'reselect';
import whitelistSelector from './whitelistSelector';
import appSelector, {
    hideNavSelector,
    roadblockSelector,
    playerTechSelector,
    webviewSelector
} from './appSelector';
import routingSelector from './routingSelector';
import { Flags } from 'enums';

const flagsSelector = createSelector(
    hideNavSelector,
    playerTechSelector,
    roadblockSelector,
    (hideNav, playerTech, roadblock) => ({
        hideNav,
        playerTech,
        roadblock: roadblock.toString()
    })
);

export const persistentFlagsSelector = createSelector(
    appSelector,
    routingSelector,
    whitelistSelector,
    webviewSelector,
    ({ isMobile }, routing, inWhitelist, isWebview) => {
        // if flags were passed in the URL, persist them
        const { locationBeforeTransitions } = routing;
        // `locationBeforeTransitions` is set to `null` on the server side, so default value assignment doesn't work
        const { pathname = '', query = {} } = locationBeforeTransitions || {};

        // take all the query params that are also flags and persist through auth
        let persistentFlags = Object.keys(Flags)
            .reduce((acc, currentFlag) => {
                const queryKey = Flags[currentFlag];
                // if query param is a flag, accumulate it
                if (query[queryKey]) {
                    acc[queryKey] = query[queryKey];
                }
                return acc;
            }, {});

        if (pathname === '/syndicated/player') {
            persistentFlags = {
                ...persistentFlags,
                type: query.type,
                dates: query.dates
            };
        }

        // special case to disable roadblock for those opted in to that experience
        if (isMobile && (inWhitelist || isWebview)) {
            persistentFlags[Flags.ROADBLOCK] = 'false';
        }

        return persistentFlags;
    }
);

export default flagsSelector;



// WEBPACK FOOTER //
// ./app/common/selectors/flagsSelector.js